import errorLogger, {
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';

import { getContext } from '@/context';
import { MINIAPP_PACKAGE_ID, MINIAPP_PACKAGE_IDS } from '@/consts/configs';

import type { Deeplink } from '../types';
import { DeeplinkKind } from '../types';

type SocialShareDeeplink = Extract<
  Deeplink,
  { kind: DeeplinkKind.SocialShare }
>;

const socialShareHandler = async ({
  fileUrl,
}: SocialShareDeeplink): Promise<void> => {
  const context = getContext();

  try {
    const storageState = context.general.sharedStorage.getState();
    await context.general.sharedStorage.dispatch({
      ...storageState,
      exportMiniapp: {
        touchpoint: MINIAPP_PACKAGE_ID,
      },
    });
  } catch (storageError) {
    errorLogger.trigger(storageError as Error, BUGSNAG_STATUSES.WARN);
  }

  try {
    await context.handlers.redirectToPackageId(
      MINIAPP_PACKAGE_IDS.SOCIAL_SHARE,
      {
        comeback: true,
        modal: true,
        path: `?state=${encodeURIComponent(
          JSON.stringify({ fileUrl, miniapp: true })
        )}`,
      }
    );
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.ERROR);
  }
};

export default socialShareHandler;
